// The season the site is pushing, if any: from `start` to `end` (month, day; both
// days included, in the visitor's own time zone) a banner on the marketing pages
// points at `page` in the visitor's language. Outside that window nothing shows,
// so this can sit here all year.
//
// `offer`: a stretch of one year's season with something extra for paying. `paidVideos`:
// the bonus AI videos for paying in that month (services/paid_season.py, granted from
// Stripe's webhook), which the banner, the Pro card and the upgrade offer say
// (tests/test_paid_season.py keeps the number equal). A season never offers free AI
// videos: there are none on the free plan since 2026-10-27, and the code that said
// "{n} free AI videos this month" is gone.
export const SEASONS = [
  {
    // Halloween ends on the 31st; Spanish keeps it two days more for el Día de Muertos (1-2 November), which its
    // banner names. On 1 November the English one still said "Halloween is coming" (the user's screenshots)
    key: 'halloween-2026', start: [10, 1], end: [10, 31], endIn: { es: [11, 2] }, page: 'niche.halloween',
    offer: { year: 2026, start: [10, 1], end: [10, 31], paidVideos: 5 },
  },
];

const dayOfYear = ([month, day]) => month * 100 + day;
const within = (date, start, end) => {
  const today = dayOfYear([date.getMonth() + 1, date.getDate()]);
  return today >= dayOfYear(start) && today <= dayOfYear(end);
};

/** The season on at `date` for a visitor reading `locale`, or null. */
export function activeSeason(date = new Date(), locale = 'en') {
  return SEASONS.find((s) => within(date, s.start, s.endIn?.[locale] || s.end)) || null;
}

const offerOn = (season, date) => {
  const offer = season?.offer;
  return Boolean(offer) && date.getFullYear() === offer.year && within(date, offer.start, offer.end);
};

/** The bonus AI videos paying during `season`'s offer gives on `date`, or null outside it. */
export function seasonPaidOffer(season, date = new Date()) {
  return offerOn(season, date) ? season.offer.paidVideos || null : null;
}
